import { store } from '../store/store'
import timeStampConverter from './time-stamp-converter'

const utils = {

  /**
   * Loader TimeOut
   * @param timeout
   */
  loaderTimeOut (timeout) {
    setTimeout(() => {
      console.log(`loader removed due to timeout of ${timeout / 1000} Seconds.`)
      store.dispatch('lightBoxloaderOn', false)
    }, timeout)
  },

  /**
   * Time difference of sdk
   * @param start
   * @param end
   * @returns {number}
   */
  timeDifference (start, end) {
    const timeTaken = end - start
    return Math.trunc(timeTaken)
  },

  /**
   * Time out Error with transaction ids
   * @param timeTaken
   * @returns {{srcTransactionId: (string|{}|getters.srcTransactionId|actions.srcTransactionId|mutations.srcTransactionId|*), error: string}}
   */
  timeOutError (timeTaken) {
    return {
      srcTransactionId: store.getters.srcTransactionId,
      error: `Timeout Error, SDK took too long to respond :  ${timeTaken} milliseconds`
    }
  },

  /**
   * convert the givne starttime and end time in ISO standard
   * @param startTime
   * @param endTime
   * @returns {}
   */
  getTimeTakenDetail (startDate, endDate) {
    let totalTimeTakenInMS = this.timeDifference(startDate.getTime(), endDate.getTime())
    const timeTakenData = {
      'Start Time': timeStampConverter.getDateAndTime(startDate),
      'End Time': timeStampConverter.getDateAndTime(endDate),
      'Total Time Taken In MS': totalTimeTakenInMS
    }
    return timeTakenData
  },

  /**
   * log time error when api/sdk  fails
   * @param startTime
   * @param error
   * @returns {{"Start Time": (*|string|*), "Total Time Taken In MS": *}}
   */
  getTimeTakenDetailsWhenError (startDate, error) {
    const timeTakenData = {
      'Start Time': timeStampConverter.getDateAndTime(startDate),
      'Total Time Taken In MS': error
    }
    return timeTakenData
  },

  isEmptyObject (data) {
    return (Object.keys(data).length === 0 && data.constructor === Object)
  },

  isArrayHasEmptyObject (arr) {
    let result
    for (let i = 0; i <= arr.length - 1; i++) {
      if (this.isEmptyObject(arr[i])) {
        return true
      } else {
        result = false
      }
    }
    return result
  },

  isJsonString (str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },

  isDateAndTimeEqual (date1, date2) {
    return new Date(date1).getTime() === new Date(date2).getTime()
  }

}

export default utils
